import { PAYMENT_CREATE } from './types';

export function createPayment(data) {
  return { type: PAYMENT_CREATE, data };
}
